<template>
<div :class="['ac-group', widthString,
        { 'ac-group-12': c12 },
        { 'ac-group-8': c8 },
        { 'ac-group-6': c6 },
        { 'ac-group-5': c5 },
        { 'ac-group-4': c4 },
        { 'ac-group-3': c3 },
        { 'ac-group-2': c2 },
        { 'ac-group-auto': auto },
        { 'ac-designer': designer },
        { 'ac-selected': selected },
        { 'ac-disabled': disabled },
    ]">
    <slot></slot>
</div>
</template>
<script>

export default {
name: 'vm-group',
props: {
    width: { type: String, default: ''},
    c12: { type: Boolean, default: false },
    c8: { type: Boolean, default: false },
    c6: { type: Boolean, default: false },
    c5: { type: Boolean, default: false },
    c4: { type: Boolean, default: false },
    c3: { type: Boolean, default: false },
    c2: { type: Boolean, default: false },
    auto: { type: Boolean, default: false },
    designer: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
},
watch: {
    width: {
        deep: false,
        handler(val) {
            this.setWidth(val);
        }
    }
},
data() {
    return {
        widthString: ''
    }
},
methods: {
    setWidth(val) {
        if (val == '12') {
            this.widthString = 'ac-group-12';
        }else if (val == '8') {
            this.widthString = 'ac-group-8';
        }else if (val == '6') {
            this.widthString = 'ac-group-6';
        }else if (val == '5') {
            this.widthString = 'ac-group-5';
        }else if (val == '4') {
            this.widthString = 'ac-group-4';
        }else if (val == '3') {
            this.widthString = 'ac-group-3';
        }else if (val == '2') {
            this.widthString = 'ac-group-2';
        }
    }
},
mounted() {
    this.setWidth(this.width);
}
}
</script>
<style scoped>

.ac-group {
    position: relative;
    float: left;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 10px;
    align-items: center;
    box-sizing: border-box;
}
.ac-group-12 {
    width: 100%;
}
.ac-group-8 {
    width: 66.6664%;
}
.ac-group-6 {
    width: 50%;
}
.ac-group-5 {
    width: 41.6667%;
}
.ac-group-4 {
    width: 33.3334%;
}
.ac-group-3 {
    width: 25%;
}
.ac-group-2 {
    width: 16.6664%;
}

.ac-group-auto {
    float: left;
    width: auto;
    margin-right: 40px;
}

@media only screen and (max-width: 600px) {

    .ac-group-8, .ac-group-6, .ac-group-4 {
        width: 100%;
    }

}

</style>
